"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class Admin extends base_1.default {
    expertsList(data = {}) {
        return this.get('/admin/experts/list', data);
    }
    editExpert(data, expertId) {
        return this.put(`/admin/experts/${expertId}`, data);
    }
    createExpert(data) {
        return this.post('/admin/experts/create', data);
    }
    getQueryLogs(data) {
        return this.get('/admin/experts/query-logs', data);
    }
    whatsNewList(data = {}) {
        return this.get('/admin/whats-new/list', data);
    }
    getSingleWhatsNew(id) {
        return this.get(`/admin/whats-new/single-whats-new/${id}`);
    }
    deleteWhatsNew(id) {
        return this.delete(`/admin/whats-new/delete/${id}`);
    }
    createWhatsNew(data = {}) {
        return this.post('/admin/whats-new/create', data);
    }
    editWhatsNew(data) {
        return this.put(`/admin/whats-new/update/${data.id}`, data.data);
    }
}
exports.default = new Admin();
